if ($("body.template-product").length) {
  if ($(".child-products").length) {
    $(".child-products").click(function (e) {
      var container = $(".Popover__MoreInfo, .Popover__MoreInfoContent");

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(this).find(".options").fadeToggle(200);
        $(this).find(".options").toggleClass("show");
        if (window.innerWidth < 1008) {
          $(".PageOverlay").toggleClass("is-visible");
          $("html").toggleClass("no-scroll");
        }
      }
    });

    $(document).click(function (e) {
      var container = $(".child-products");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.find(".options").fadeOut(200);
        container.find(".options").removeClass("show");
      }
    });

    $(".PageOverlay").click(function () {
      $(".PageOverlay").removeClass("is-visible");
      $("html").removeClass("no-scroll");
    });

    $(".child-products .option").click(function () {
      var container = $(this).closest(".child-products"),
        selected = container.find(".selected"),
        thisEle = $(this);
      $(".child-products .option").removeClass("active");
      thisEle.addClass("active");
      selected.find(".value").text(thisEle.text());

      // trigger variant:changed
      let option1text = $(
        ".Product__Info .ProductForm__Item .ProductForm__SelectedValue"
      )
        .first()
        .text();
      $('[data-action="select-value"][data-option-position="1"]').each(
        function () {
          if ($(this).text() == option1text) $(this).click();
        }
      );

      $(".child-products .options").fadeOut(200);
      $(".child-products .options").removeClass("show");
      $(".PageOverlay").removeClass("is-visible");
      $("html").removeClass("no-scroll");
      return false;
    });

    $(".ProductForm__AddToCart").click(function () {
      let childVariant = $(
        ".child-products .option.active:not(.none):not(.disabled)"
      );
      if (childVariant.length) {
        $(this).attr("disabled", "disabled");
        const fillingId = new Date().getTime();
        let mainVariantQty = parseInt(
          $(
            ".ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity"
          ).val()
        );
        let foamId = childVariant.attr("product-id");

        const childItemsArrayString = `
          [{"${childVariant.attr("option2kgid")}":${parseInt(
          childVariant.attr("option2kgqty")
        )}},{"${childVariant.attr("option3kgid")}":${parseInt(
          childVariant.attr("option3kgqty")
        )}}]
        `.trim();

        let dataAjax = {
          items: [
            {
              quantity: mainVariantQty,
              id: $('.Product__InfoWrapper .ProductForm [name="id"]').val(),
              properties: {
                "_filling-id": fillingId,
                "foam-id": foamId,
                "foam-title": childVariant.text(),
                "foam-price2kg": childVariant.attr("option2kgprice"),
                "foam-price3kg": childVariant.attr("option3kgprice"),
                "child-items": childItemsArrayString, // Add child-item variants and quantities to line item properties
              },
            },
            {
              quantity:
                mainVariantQty * parseInt(childVariant.attr("option2kgqty")),
              id: childVariant.attr("option2kgid"),
              properties: {
                "_filling-id": fillingId,
                "foam-id": foamId,
                "is-child": "true",
              },
            },
            {
              quantity:
                mainVariantQty * parseInt(childVariant.attr("option3kgqty")),
              id: childVariant.attr("option3kgid"),
              properties: {
                "_filling-id": fillingId,
                "foam-id": foamId,
                "is-child": "true",
              },
            },
          ],
        };
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          async: false,
          data: dataAjax,
          success: function (cart) {
            window.location.href = "/cart";
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error(jqXHR.responseText);
            location.reload();
          },
        });
        return false;
      }
    });

    $(".child-products .selected").attr(
      "normal-price",
      $(".ProductMeta__Price").text()
    );

    // change custom price
    $(document).on("variant:changed", function (event) {
      var newVariant = event.detail.variant;
      changeQtyChildProduct(newVariant);
      _updateProductPrices(newVariant);
    });

    function changeQtyChildProduct(variant) {
      let variantTitle = variant.title.toLowerCase();

      $(".child-products .option:not(.none)").each(function () {
        let child_title = $(this).text().toLowerCase();
        if (child_title.includes("100%")) {
          if (
            variantTitle.includes("x large") ||
            variantTitle.includes("xlarge")
          ) {
            $(this).attr("option2kgqty", 1).attr("option3kgqty", 5);
          } else if (variantTitle.includes("large")) {
            $(this).attr("option2kgqty", 2).attr("option3kgqty", 3);
          } else {
            $(this).attr("option2kgqty", 1).attr("option3kgqty", 2);
          }
        } else if (
          child_title.includes("partial") ||
          child_title.includes("50%")
        ) {
          if (
            variantTitle.includes("x large") ||
            variantTitle.includes("xlarge")
          ) {
            $(this).attr("option2kgqty", 1).attr("option3kgqty", 3);
          } else if (variantTitle.includes("large")) {
            $(this).attr("option2kgqty", 1).attr("option3kgqty", 2);
          } else {
            $(this).attr("option2kgqty", 1).attr("option3kgqty", 1);
          }
        }
      });
    }

    function _updateProductPrices(newVariant) {
      var productMetaPrices = document.querySelector(".ProductMeta__PriceList");
      var btnPrice = document.querySelector(".btnPrice");

      let childPrice = 0;
      let childVariant = $(
        ".child-products .option.active:not(.none):not(.disabled)"
      );

      if (childVariant.length) {
        childPrice = parseInt(
          childVariant.attr("option2kgprice") *
            childVariant.attr("option2kgqty") +
            childVariant.attr("option3kgprice") *
              childVariant.attr("option3kgqty")
        );
      }

      if (!newVariant) {
        productMetaPrices.style.display = "none";
      } else {
        productMetaPrices.innerHTML = "";
        btnPrice.innerHTML = "";

        btnPrice.innerHTML += "Add to cart";
        btnPrice.innerHTML += '<span class="Button__SeparatorDot"></span>';
        btnPrice.innerHTML += "<span >".concat(
          formatMoney(
            newVariant["price"] + childPrice,
            window.theme.moneyFormat
          ),
          "</span>"
        );

        if (newVariant["compare_at_price"] > newVariant["price"]) {
          productMetaPrices.innerHTML +=
            '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>'.concat(
              formatMoney(
                newVariant["price"] + childPrice,
                window.theme.moneyFormat
              ),
              "</span>"
            );
          productMetaPrices.innerHTML +=
            '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>'.concat(
              formatMoney(
                newVariant["compare_at_price"] + childPrice,
                window.theme.moneyFormat
              ),
              "</span>"
            );
        } else {
          productMetaPrices.innerHTML +=
            '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>'.concat(
              formatMoney(
                newVariant["price"] + childPrice,
                window.theme.moneyFormat
              ),
              "</span>"
            );
        }

        productMetaPrices.style.display = "";
      }
    }

    function formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || "${{amount}}";

      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);
        var parts = number.split("."),
          dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          ),
          centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }

      var value = "";

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;

        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;

        case "amount_with_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ".");
          break;

        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ",", ".");
          break;

        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;

        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
      }

      if (formatString.indexOf("with_comma_separator") !== -1) {
        return formatString.replace(placeholderRegex, value).replace(",00", "");
      } else {
        return formatString.replace(placeholderRegex, value).replace(".00", "");
      }
    }

    console.log("init");
  }
}
